<section class="seccion">

    <div class="cw " fxLayout="column"  fxFlex="50%" fxFlex.lt-lg="75%" fxFlex.lt-md="100%" fxLayoutAlign="center">

        <div fxLayout="column"  fxFlex="50%" fxFlex.lt-lg="75%" fxFlex.lt-md="100%" fxLayoutAlign="center">

            <div *ngIf="resultado>=70 ; else intentoFallido" fxLayout="column" fxLayoutAlign=" center">
                <h3>¡Felicitaciones!</h3>
                <h5>Has conseguido una calificacion de {{this.resultado}} / 100.</h5>
                <h6 class="centertext ft14">Has culminado el curso exitosamente. Podras descargar tu certificado desde la pagina de progreso del curso.</h6>
                <br>
                <button routerLink="/est/mi-curso/{{cursoId}}" class="darkButton">Continuar</button>
                <br>
            </div>

            <ng-template #intentoFallido>
                <div fxLayout="column" fxLayoutAlign=" center">
                    <h3>¡Vaya! </h3>
                    <h5>Has conseguido una calificacion de {{this.resultado}} / 100.</h5>
                    <h6 class="centertext ft14">Requieres una califiación igual o mayor a 70 para aprobar. Intentalo nuevamente.</h6>
                    <br>
                    <button routerLink="/est/cuestionario/{{cursoId}}" class="darkButton">Intentar nuevamente</button>
                </div>
            </ng-template>

            <!-- Preguntas -->
            <div *ngIf="resultado>=70">
                <p class="centertext fw">Este ha sido el resultado de tu examen:</p>
                <div *ngFor="let item of presentacionResultados;  let pregIndex=index"  >
                    <div class="mgb20 border pd10 radius3">
                        <div class="backGray3 mgb10" *ngIf="this.imagenes[pregIndex].url">
                            <img src={{this.imagenes[pregIndex].url}} alt="" class="fotoPregunta radius3">
                        </div>
    
                        <div fxLAyout="row" class="mgt05 mgb10">
    
                            <div fxLayout="row" fxLayoutGap="1rem" *ngIf="this.notas[pregIndex]===1">
                                <mat-icon class="green-5">check</mat-icon>
                                <span class="mgl10 ft500 ft15 green-5">{{pregIndex + 1}}. {{item.pregunta}}</span>
                            </div>
                            <div fxLayout="row" fxLayoutGap="1rem" *ngIf="this.notas[pregIndex]===0">
                                <mat-icon class="red-5">close</mat-icon>
                                <span class="mgl10 ft500 ft15 red-5">{{pregIndex + 1}}. {{item.pregunta}}</span>
                            </div>
                        </div>
    
                        <div *ngFor="let item of presentacionResultados[pregIndex].opciones;  let optIndex=index">
                            <div fxLayout="row" fxLayoutAlign="space-between" class="mgt05">
    
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="backGreen5 pd05 radius3 fw"
                                    *ngIf="this.verificacion[pregIndex].opciones[optIndex]==2">
                                    <span class="gray-1">{{optIndex + 1}}. {{this.presentacionResultados[pregIndex].opciones[optIndex]}}</span>
                                    <mat-icon class="gray-1 linkIcon">check</mat-icon>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="backRed5 pd05 radius3 fw"
                                    *ngIf="this.verificacion[pregIndex].opciones[optIndex]==1">
                                    <span class="gray-1">{{optIndex + 1}}. {{this.presentacionResultados[pregIndex].opciones[optIndex]}}</span>
                                    <mat-icon class="gray-1 linkIcon">close</mat-icon>
                                </div>
                                <div class="pd05 radius3 fw" *ngIf="this.verificacion[pregIndex].opciones[optIndex]==0">
                                    <span>{{optIndex + 1}}. {{this.presentacionResultados[pregIndex].opciones[optIndex]}}</span>
                                </div>
                            </div>
    
                        </div>
                        <div  *ngIf="this.notas[pregIndex]===0">
                            <div class="mg05">
                                <hr>
                            </div>
        
                            <p class="ft500 gray-7 ft14">Respuesta correcta:</p>
                            <div *ngFor="let item of presentacionResultados[pregIndex].opciones; let optIndex=index">
                                <div *ngFor="let item of presentacionResultados[pregIndex].correctas; let correctasIndex=index">
                                    <span *ngIf="this.presentacionResultados[pregIndex].correctas[correctasIndex]-1===optIndex">
                                        <span class="mgl05 mgr05 ft11">{{optIndex +1}}. {{this.presentacionResultados[pregIndex].opciones[optIndex]}}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
